import { render, staticRenderFns } from "./PrinciplesCoachSetup.vue?vue&type=template&id=f46496a2&"
import script from "./PrinciplesCoachSetup.vue?vue&type=script&lang=js&"
export * from "./PrinciplesCoachSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports